export const FETCHING_TARGETED_CONTENT = "FETCHING_TARGETED_CONTENT";
export const FETCHED_TARGETED_CONTENT = "FETCHED_TARGETED_CONTENT";
export const GET_STORED_TARGETED_CONTENT = "GET_STORED_TARGETED_CONTENT";
export const API_ERROR = "API_ERROR";

export const STATUS_IDLE = "IDLE";
export const STATUS_FETCHING = "FETCHING";
export const STATUS_SUCCESS = "SUCCESS";
export const STATUS_ERROR = "ERROR";
